import { Button, Footer, TitleBar } from '../../components';
import GenericListManager from '../../components/generic/ListManager/GenericListManager';
import { useState } from 'react';
import { BusinessFunctionAddModal } from './BusinessFunctionAddModal';
import TitleUpdater from '../../components/common/TitleUpdater';
import { DocumentNode } from 'graphql';
import { RefetchQueries } from '../../interfaces/GraphQLTypes';

type BusinessFunctionsSelectionBaseProps = {
  title: string;
  subtitle: string;
  brief: string;
  backPath: string;
  fetchAllQuery: {
    query: DocumentNode;
    identifier: string;
    variables?: Record<string, any>;
  };
  fetchSelectedQuery: {
    query: DocumentNode;
    identifier: string;
    variables?: Record<string, any>;
  };
  updateMutation: {
    mutation: DocumentNode;
    variableName?: string;
    variableStructure?: Record<string, any>;
    formatFunction?: (itemUuid: string) => any;
  };
  refetchQueries?: RefetchQueries;
};

export const BusinessFunctionsSelectionBase = ({
  title,
  subtitle,
  brief,
  backPath,
  fetchAllQuery,
  fetchSelectedQuery,
  updateMutation,
  refetchQueries,
}: BusinessFunctionsSelectionBaseProps) => {
  const [businessFunctionModalOpen, setBusinessFunctionModalOpen] =
    useState(false);

  const handleAddBusinessFunction = () => setBusinessFunctionModalOpen(true);

  const extendOptions = (
    <Button
      type="primary"
      onClick={handleAddBusinessFunction}
      className="font-normal min-w-[150px] bg-white"
    >
      Add Function
    </Button>
  );

  return (
    <div>
      <TitleUpdater title={title} />
      <TitleBar title={title} subtitle={subtitle} brief={brief} />
      <GenericListManager
        addedTitle="Added Business Functions"
        availableTitle="All Business Functions"
        fetchAllQuery={fetchAllQuery}
        fetchSelectedQuery={fetchSelectedQuery}
        itemKey="uuid"
        itemLabel="name"
        updateMutation={updateMutation}
        extendOptions={extendOptions}
      />
      <Footer backPath={backPath} />
      <BusinessFunctionAddModal
        isOpen={businessFunctionModalOpen}
        onClose={() => setBusinessFunctionModalOpen(false)}
        refetchQueries={refetchQueries}
      />
    </div>
  );
};
